import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ExternalApplicationWizard from "../modules/external-formulary/ExternalApplicationWizard";
import ApplicationConfirmation from "../modules/external-formulary/ApplicationConfirmation";

function ExternalFormulary() {
  return (
    <div className="main-content d-flex flex-column min-vh-100">
      {/* Header */}
      <nav className="navbar navbar-expand-lg navbar-dark" style={{ background: 'linear-gradient(to right, #00C6FF, #0072FF)' }}>
        <div className="container">
          <a className="navbar-brand" href="/">
            <img 
              src={require("assets/img/brand/nlf-logo.png")} 
              alt="NLF" 
              className="mr-2"
              style={{ height: '35px' }}
            />
            Next Level Funding
          </a>
          <span className="navbar-text ml-auto">
            Credit Application
          </span>
        </div>
      </nav>

      {/* Main content area */}
      <div className="container-fluid flex-grow-1">
          <Routes>
            <Route path="" element={<ExternalApplicationWizard />} />
            <Route path="confirmation" element={<ApplicationConfirmation />} />
            <Route path="*" element={<Navigate to="" replace />} />
          </Routes>
      </div>

      {/* Footer */}
      <footer className="bg-light py-4 mt-auto">
        <div className="container text-center">
          <p className="text-muted mb-0">
            © 2025 Next Level Funding. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default ExternalFormulary;
